export default __webpack_public_path__ + "static/media/gear.a33d5610.png";